import { __assign } from 'tslib';
import React__default, { forwardRef } from 'react';
import { IconButton } from '@mui/material';
import clsx from 'clsx';
import { classes } from './index.styled.js';

var KButtonAction = forwardRef(function (props, ref) {
    var _a;
    return (React__default.createElement(IconButton, __assign({ ref: ref, "data-testid": props.testId, color: "primary" }, props, { className: clsx("KButton", props.className, classes.actionButton, props.actionButtonName && "".concat(classes.actionButton, "-").concat(props.actionButtonName), (_a = {},
            _a[classes.disabled] = props.disabled,
            _a)) }), props.children));
});

export { KButtonAction as default };
//# sourceMappingURL=index.js.map
